import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Swal from "sweetalert2";
import logo from "../src/assets/logo.webp";
import whatsappicon from "../src/assets/img/whatsappicon.gif";

function ForgetPass() {
  const [mobile, setMobile] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");
  const [otpSent, setOtpSent] = useState(false);
  const [userTempId, setUserTempId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [logoImage, setLogoImage] = useState(null);
  const [whatsappNumber, setWhatsappNumber] = useState("");

  const navigate = useNavigate();
  const isAdmin = localStorage.getItem("isAdmin");

  useEffect(() => {
    if (isAdmin === "false") {
      navigate("/HomePage");
    }
  }, [isAdmin, navigate]);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL_NODE}admin/settings`);
      const result = await response.json();
      setLogoImage(result[0]?.logo || result.logo || null);
      setWhatsappNumber(result?.whatsapp_no || "");
    } catch (error) {
      console.error("Error fetching settings:", error);
    }
  };

  const handleSendOtp = async () => {
    if (!mobile || mobile.length !== 10) {
      return Swal.fire("Error", "Please enter a valid 10-digit mobile number", "error");
    }

    setLoading(true);
    try {
      const res = await axios.post(`https://api.Cash365days.in/user/forget-password-send-otp`, {
        mobileNumber: mobile,
      });

      if (res.data.status === 1) {
        setOtpSent(true);
        setUserTempId(res.data.userTempId);
        Swal.fire("Success", res.data.message || "OTP sent successfully", "success");
      } else {
        Swal.fire("Error", res.data.message || "Failed to send OTP", "error");
      }
    } catch (error) {
      Swal.fire("Error", error.response?.data?.message || "Server error", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleChangePassword = async () => {
    if (!otp || !password || !confirmPassword) {
      return Swal.fire("Error", "Please fill in all fields", "error");
    }
    if (password !== confirmPassword) {
      return Swal.fire("Error", "Passwords do not match", "error");
    }

    setLoading(true);
    try {
      const res = await axios.post(`https://api.Cash365days.in/user/forget-password`, {
        otp,
        userTempId,
        newPassword: password,
      });

      if (res.data.status === 1) {
        Swal.fire("Success", res.data.message || "Password changed successfully", "success");
        navigate("/");
      } else {
        Swal.fire("Error", res.data.message || "Failed to reset password", "error");
      }
    } catch (error) {
      Swal.fire("Error", error.response?.data?.message || "Server error", "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <section className="login_area py-5">
      <div className="container">
        <div className="row align-items-center g-4">
          <div className="col-xl-6 offset-xl-3">
            <div className="hfive_card p-6 p-sm-9 rounded-3">
              <div className="d-flex justify-content-center">
                {whatsappNumber && (
                  <a href={`https://wa.me/+91${whatsappNumber}`} target="_blank" rel="noopener noreferrer">
                    <div className="whatsappicon">
                      <img className="whatsapp-img" src={whatsappicon} alt="WhatsApp" />
                    </div>
                  </a>
                )}
              </div>

              <div className="text-center">
                <img
                  className="img-fluid logo-color mt-3"
                  src={logoImage ? `https://api.Cash365days.in/uploads/${logoImage}` : logo}
                  alt="Logo"
                  width={200}
                />
              </div>

              <div className="login-content">
                <h2 className="h4 fw-bold">Forgot Password?</h2>
                <p>Reset your password using OTP</p>

                <form>
                  <div className="d-flex flex-column gap-4">
                    <div>
                      <label>Mobile Number</label>
                      <input
                        type="text"
                        className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25  py-2 rounded-3"
                        placeholder="Enter Mobile Number"
                        value={mobile}
                        onChange={(e) => setMobile(e.target.value)}
                        disabled={otpSent}
                      />
                    </div>
                    

                    {!otpSent ? (
                      <button
                        type="button"
                        className="btn px-6 bg-gradient-1 rounded-3 border-0 mt-2 w-100"
                        onClick={handleSendOtp}
                        disabled={loading}
                      >
                        {loading ? "Sending OTP..." : "Send OTP"}
                      </button>
                    ) : (
                      <>
                        <div>
                          <label>Enter OTP</label>
                          <input
                            type="text"
                            className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25  py-2 rounded-3"
                            placeholder="Enter OTP"
                            value={otp}
                            onChange={(e) => setOtp(e.target.value)}
                          />
                        </div>
                        <div>
                          <label>New Password</label>
                          <input
                            type="password"
                            className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25  py-2 rounded-3"
                            placeholder="Enter New Password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                          />
                        </div>
                        <div>
                          <label>Confirm Password</label>
                          <input
                            type="password"
                            className="form-control bg-transparent border border-1 colorchange border-white border-opacity-25  py-2 rounded-3"
                            placeholder="Confirm Password"
                            value={confirmPassword}
                            onChange={(e) => setConfirmPassword(e.target.value)}
                          />
                        </div>
                        <button
                          type="button"
                          className="btn px-6 bg-gradient-1 rounded-3 border-0 mt-2 w-100"
                          onClick={handleChangePassword}
                          disabled={loading}
                        >
                          {loading ? "Resetting Password..." : "Reset Password"}
                        </button>
                      </>
                    )}
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default ForgetPass;
